/**
 * The gifts a club offers: the items of the gift sections when the club has
 * sections, otherwise the top level items. Items without sku are dropped and
 * duplicates (same sku) are collapsed to the first occurrence.
 */
export const getAvailableGiftItems = (giftConfig) => {
    const sectionItems = giftConfig.sections?.flatMap((section) => section.items) ?? [];
    return (sectionItems.length > 0 ? sectionItems : giftConfig.items)
        .filter((item) => Boolean(item.sku))
        .filter((item, index, list) => list.findIndex((candidate) => candidate.sku === item.sku) === index);
};
